import { render, staticRenderFns } from "./NewAvailabilityHeader.vue?vue&type=template&id=3174f4c8&scoped=true"
import script from "./NewAvailabilityHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewAvailabilityHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewAvailabilityHeader.vue?vue&type=style&index=0&id=3174f4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174f4c8",
  null
  
)

export default component.exports